import keycloakService from '../../keycloak_service';

import { postToSinatra } from '../api_utils';

const editUser = (user = {}) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({
      id: user?.id,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      isAdmin: user?.isAdmin || false,
      enabled: user?.isActive || false,
    })
  };

  return postToSinatra('v1/api/user', fetchOptions);
};

export default editUser;
